import { Controller } from '@hotwired/stimulus';

export default class FormCompletenessController extends Controller {
  static targets = ['submit', 'checkboxGroup', 'sumValid'];

  connect() {
    this.element.addEventListener('input', this.check);
    this.element.addEventListener('change', this.check);
    this.initialCheckHandle = requestAnimationFrame(() => this.check());
  }

  disconnect() {
    this.element.removeEventListener('input', this.check);
    this.element.removeEventListener('change', this.check);
    if (this.initialCheckHandle) cancelAnimationFrame(this.initialCheckHandle);
  }

  check = () => {
    let complete = true;
    const radioGroups = {};

    this.element.querySelectorAll('input, select, textarea').forEach((field) => {
      if (field.type === 'submit' || field.type === 'hidden' || field.type === 'checkbox' || field.disabled) return;

      if (field.type === 'radio') {
        radioGroups[field.name] = radioGroups[field.name] || false;
        if (field.checked) radioGroups[field.name] = true;
      } else {
        if (field.value === '') complete = false;
      }
    });

    Object.keys(radioGroups).forEach((name) => {
      if (!radioGroups[name]) complete = false;
    });

    this.checkboxGroupTargets.forEach((group) => {
      const anyChecked = group.querySelectorAll('input[type="checkbox"]:checked').length > 0;
      if (!anyChecked) complete = false;
    });

    this.sumValidTargets.forEach((el) => {
      if (!el.classList.contains('text-success')) complete = false;
    });

    this.submitTarget.disabled = !complete;
  }
}
